module.exports = __webpack_public_path__ + "media/images/journey-day01-e32028e5e2394958a700bd9c16517b01.jpg";